import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.timers";

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { isIOS } from '../../../lib/device/operating-system'; // called by the framework to close an open ChildWindow. Contains a
// workaround to deal with VoiceOver’s inability to consistently 
// follow visual focus.

var closeiOSChildWindow = function closeiOSChildWindow(event) {
  event.preventDefault();
  event.stopPropagation();
  return new Promise(function (resolve) {
    setTimeout(function () {
      window.history.go(-1);
      setTimeout(function () {
        return resolve();
      }, 200);
    }, 10);
  });
};

var closeChildWindow = function closeChildWindow(event) {
  event.preventDefault();
  event.stopPropagation();
  return new Promise(function (resolve) {
    window.history.go(-1);
    setTimeout(function () {
      return resolve();
    }, 200);
  });
};

export default (function (event) {
  return isIOS() ? closeiOSChildWindow(event) : closeChildWindow(event);
});